import{normaliseUrlPathname}from"@olmokit/utils/normaliseUrlPathname";import ajaxLaravel from"../ajax/laravel";/**
 * Fragment ajax request
 *
 * Wraps the `ajaxLaravel` submit prefixing the given endpoint with the standard
 * prefix used by `src/fragments/routes.php`, that is `/_/fragments/`
 *
 * TODO: config(env.URL_TRAILING_SLASH)
 */export default function ajax(endpoint,options){let parts=endpoint.split("?"),url=normaliseUrlPathname("/_/fragments/"+parts[0])+"/";return ajaxLaravel(// add query params if needed
url+=parts[1]?`?${parts[1]}`:"",options)}/**
 * Fragment ajax GET alias
 *
 * @lends {ajax}
 */export const get=(endpoint,options)=>ajax(endpoint,{...options,method:"POST"});/**
 * Fragment ajax POST shortcut
 */export const post=(endpoint,options)=>ajax(endpoint,{...options,method:"POST"});